/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BasicFile,
    BasicFileFromJSON,
    BasicFileFromJSONTyped,
    BasicFileToJSON,
} from './';

/**
 * 
 * @export
 * @interface FilePartialUpdate
 */
export interface FilePartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof FilePartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {Array<BasicFile>}
     * @memberof FilePartialUpdate
     */
    files?: Array<BasicFile> | null;
    /**
     * 
     * @type {string}
     * @memberof FilePartialUpdate
     */
    parent?: string;
    /**
     * 
     * @type {string}
     * @memberof FilePartialUpdate
     */
    mode?: string;
    /**
     * 
     * @type {number}
     * @memberof FilePartialUpdate
     */
    uid?: number;
    /**
     * 
     * @type {number}
     * @memberof FilePartialUpdate
     */
    gid?: number;
    /**
     * 
     * @type {string}
     * @memberof FilePartialUpdate
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof FilePartialUpdate
     */
    group?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    recursive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FilePartialUpdate
     */
    affinity?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeSetuid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeSetgid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeSetvfx?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeUserRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeUserWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeUserExecute?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeGroupRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeGroupWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeGroupExecute?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeOthersRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeOthersWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilePartialUpdate
     */
    modeOthersExecute?: boolean;
}

export function FilePartialUpdateFromJSON(json: any): FilePartialUpdate {
    return FilePartialUpdateFromJSONTyped(json, false);
}

export function FilePartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilePartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'files': !exists(json, 'files') ? undefined : (json['files'] === null ? null : (json['files'] as Array<any>).map(BasicFileFromJSON)),
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'mode': !exists(json, 'mode') ? undefined : json['mode'],
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'group': !exists(json, 'group') ? undefined : json['group'],
        'recursive': !exists(json, 'recursive') ? undefined : json['recursive'],
        'affinity': !exists(json, 'affinity') ? undefined : json['affinity'],
        'modeSetuid': !exists(json, 'mode_setuid') ? undefined : json['mode_setuid'],
        'modeSetgid': !exists(json, 'mode_setgid') ? undefined : json['mode_setgid'],
        'modeSetvfx': !exists(json, 'mode_setvfx') ? undefined : json['mode_setvfx'],
        'modeUserRead': !exists(json, 'mode_user_read') ? undefined : json['mode_user_read'],
        'modeUserWrite': !exists(json, 'mode_user_write') ? undefined : json['mode_user_write'],
        'modeUserExecute': !exists(json, 'mode_user_execute') ? undefined : json['mode_user_execute'],
        'modeGroupRead': !exists(json, 'mode_group_read') ? undefined : json['mode_group_read'],
        'modeGroupWrite': !exists(json, 'mode_group_write') ? undefined : json['mode_group_write'],
        'modeGroupExecute': !exists(json, 'mode_group_execute') ? undefined : json['mode_group_execute'],
        'modeOthersRead': !exists(json, 'mode_others_read') ? undefined : json['mode_others_read'],
        'modeOthersWrite': !exists(json, 'mode_others_write') ? undefined : json['mode_others_write'],
        'modeOthersExecute': !exists(json, 'mode_others_execute') ? undefined : json['mode_others_execute'],
    };
}

export function FilePartialUpdateToJSON(value?: FilePartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'files': value.files === undefined ? undefined : (value.files === null ? null : (value.files as Array<any>).map(BasicFileToJSON)),
        'parent': value.parent,
        'mode': value.mode,
        'uid': value.uid,
        'gid': value.gid,
        'user': value.user,
        'group': value.group,
        'recursive': value.recursive,
        'affinity': value.affinity,
        'mode_setuid': value.modeSetuid,
        'mode_setgid': value.modeSetgid,
        'mode_setvfx': value.modeSetvfx,
        'mode_user_read': value.modeUserRead,
        'mode_user_write': value.modeUserWrite,
        'mode_user_execute': value.modeUserExecute,
        'mode_group_read': value.modeGroupRead,
        'mode_group_write': value.modeGroupWrite,
        'mode_group_execute': value.modeGroupExecute,
        'mode_others_read': value.modeOthersRead,
        'mode_others_write': value.modeOthersWrite,
        'mode_others_execute': value.modeOthersExecute,
    };
}


